var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9L13 9C11.9643 9 11.113 8.21278 11.0107 7.2041L11 7L11 0.5L3.5 0.500001C1.84314 0.500001 0.499999 1.84315 0.499999 3.5L0.5 12.5C0.500002 14.1569 1.84315 15.5 3.5 15.5L16.5 15.5C18.1569 15.5 19.5 14.1569 19.5 12.5L19.5 9ZM19.4902 7C19.4402 6.276 19.1317 5.59163 18.6133 5.07715L14.877 1.37012C14.3712 0.868407 13.7052 0.56733 13 0.511719L13 7L19.4902 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultIcon);
export default __webpack_public_path__ + "static/media/vault-icon.1d46a93bde045ea0c55169856054d5d8.svg";
export { ForwardRef as ReactComponent };